<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="13" viewBox="0 0 22 13" fill="none">
    <path d="M21.1367 2.0797L11.0795 12.137L9.49148 10.549L9.49948 10.5408L0.773134 1.81504L2.36112 0.227051L11.088 8.95304L19.5487 0.491715L21.1367 2.0797Z" fill="#010101"/>
  </svg>
</template>